import { ComponentPropsWithoutRef, forwardRef, ReactNode } from "react";
import { ErrorBoundary as EB, FallbackProps } from "react-error-boundary";

import styles from "./error-boundary.module.scss";

type ErrorBoundaryProps = {
  /** The children to wrap */
  children: ReactNode;
} & ComponentPropsWithoutRef<"div">;

const ErrorBoundary = forwardRef<HTMLDivElement, ErrorBoundaryProps>(
  ({ children, ...rest }, ref) => {
    const Fallback = ({ error }: FallbackProps) => (
      <div className={styles.errorComponent} {...rest} ref={ref}>
        <p>
          <strong>Oops! An error occured!</strong>
        </p>
        <pre>
          <strong>Error:</strong> {error.message}
        </pre>
        <pre>
          <strong>Stacktrace:</strong> {error.stack}
        </pre>
      </div>
    );

    return <EB FallbackComponent={Fallback}>{children}</EB>;
  }
);

ErrorBoundary.displayName = "ErrorBoundary";

export default ErrorBoundary;
